import React from 'react';
import { motion } from 'framer-motion';
import { skills } from '../data/data';
import { staggerContainer, fadeInUp } from '../lib/motion';

const Skills = () => {
  const categories = [
    { title: 'Backend', items: skills.backend },
    { title: 'Distributed Systems', items: skills.distributed },
    { title: 'AI Engineering', items: skills.ai },
    { title: 'Data & Storage', items: skills.data },
    { title: 'Cloud & DevOps', items: skills.cloud },
    { title: 'Frontend', items: skills.frontend },
    { title: 'Security & Testing', items: skills.securityTesting }
  ];

  return (
    <section id="skills" className="py-24 bg-[#f8f8f6]">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8 mb-20">
          <div className="col-span-12 lg:col-span-4">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7 }}
            >
              <p className="text-xs uppercase tracking-widest text-[#666666] mb-4" style={{ fontFamily: 'var(--font-sans)' }}>
                Expertise
              </p>
              <h2 className="text-5xl font-normal text-[#1a1a1a]" style={{ fontFamily: 'var(--font-serif)' }}>
                Skills
              </h2>
            </motion.div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            <motion.div
              className="space-y-16"
              variants={staggerContainer}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true, margin: "-100px" }}
            >
              {categories.map((category, catIndex) => (
                <motion.div
                  key={category.title}
                  variants={fadeInUp}
                  className="border-t border-[#d4d4d0] pt-8"
                >
                  <h3 className="text-2xl font-normal text-[#1a1a1a] mb-8" style={{ fontFamily: 'var(--font-serif)' }}>
                    {category.title}
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-4">
                    {category.items.map((skill, idx) => (
                      <motion.div
                        key={idx}
                        className="group"
                        whileHover={{ x: 4, transition: { duration: 0.2 } }}
                      >
                        <span
                          className="text-base text-[#666666] group-hover:text-[#1a1a1a] transition-colors duration-300 inline-block relative"
                          style={{ fontFamily: 'var(--font-sans)', fontWeight: 300 }}
                        >
                          {skill}
                          <motion.span
                            className="absolute -bottom-1 left-0 h-[1px] bg-[#8B4513]"
                            initial={{ width: 0 }}
                            whileHover={{ width: '100%' }}
                            transition={{ duration: 0.3 }}
                          />
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;